/* ============================================================
   GLTRverse — luxury.js
   Loads BEFORE theme.js so the auto-tagged .reveal elements
   are in place when theme.js's IntersectionObserver runs.
   1. Auto scroll-reveal: tags content across ALL sections so
      every page gets the staggered editorial entrance without
      editing 38 section files.
   2. Sticky mobile add-to-cart visibility on product pages.
   3. Page entrance fade.
   ============================================================ */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body = document.body;

  /* ---------- 3. page entrance ---------- */
  if (!reduced && body.classList.contains('lux-fade')) {
    body.classList.add('lux-fade-ready');
  }

  /* ---------- 1. auto scroll-reveal ---------- */
  if (!reduced && !body.classList.contains('lux-no-reveal')) {
    var main = document.getElementById('MainContent');
    if (main) {
      var EXCLUDE = '.hero--concept, .cart-drawer, [data-popup], .lux-sticky-atc, noscript, [data-pdp]';
      var SELECTOR = [
        'h1', 'h2', 'h3',
        '.eyebrow', '.t-eyebrow',
        'p', 'blockquote', 'figure',
        '.btn', '.product-card',
        '.image-row__cell', '.assurance', '.faq-item'
      ].join(',');

      var sections = main.querySelectorAll('.shopify-section');
      sections.forEach(function (section) {
        if (section.querySelector('.hero--concept')) return;

        var candidates = section.querySelectorAll(SELECTOR);
        var count = 0;
        for (var i = 0; i < candidates.length; i++) {
          var el = candidates[i];
          if (count >= 14) break;                          // cap per section
          if (el.classList.contains('reveal')) continue;   // already authored
          if (el.closest(EXCLUDE)) continue;               // excluded zones
          if (el.closest('.reveal') && el.closest('.reveal') !== el) continue; // parent already animates
          // skip elements nested inside an already-tagged candidate (e.g. p inside .product-card)
          var parentTagged = el.parentElement && el.parentElement.closest('[data-lux-reveal]');
          if (parentTagged) continue;

          el.classList.add('reveal');
          el.setAttribute('data-lux-reveal', '');
          el.style.transitionDelay = (Math.min(count % 5, 4) * 0.07) + 's';
          count++;
        }
      });

      // Own observer — guarantees reveal even if theme.js changes.
      // Safety net: anything still hidden after 2.5s becomes visible.
      var all = main.querySelectorAll('.reveal');
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
          });
        }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });
        all.forEach(function (el) { io.observe(el); });
        setTimeout(function () {
          main.querySelectorAll('.reveal:not(.is-visible)').forEach(function (el) {
            var r = el.getBoundingClientRect();
            if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
          });
        }, 2500);
      } else {
        all.forEach(function (el) { el.classList.add('is-visible'); });
      }
    }
  } else if (reduced) {
    // ensure nothing stays hidden
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- 2. sticky mobile add-to-cart ---------- */
  var sticky = document.querySelector('[data-lux-sticky-atc]');
  var pdpScope = document.querySelector('[data-pdp]');
  if (sticky && pdpScope) {
    var mainBtn = pdpScope.querySelector('button[name="add"]');
    var stickyBtn = sticky.querySelector('[data-lux-sticky-add]');
    var stickyPrice = sticky.querySelector('[data-lux-sticky-price]');
    var pdpPrice = document.querySelector('[data-dynamic-price]');

    if (mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // show the bar only once the real button has scrolled ABOVE the viewport
          var below = en.boundingClientRect.top > 0;
          var active = !en.isIntersecting && !below;
          sticky.classList.toggle('is-active', active);
          sticky.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(mainBtn);
    }

    if (stickyBtn && mainBtn) {
      stickyBtn.addEventListener('click', function () { mainBtn.click(); });
      // mirror availability + label
      var sync = function () {
        stickyBtn.disabled = mainBtn.disabled;
        stickyBtn.textContent = mainBtn.textContent.trim();
        if (stickyPrice && pdpPrice) stickyPrice.textContent = pdpPrice.textContent;
      };
      sync();
      new MutationObserver(sync).observe(mainBtn, { childList: true, attributes: true, subtree: true });
      if (pdpPrice) new MutationObserver(sync).observe(pdpPrice, { childList: true, subtree: true });
    }
  }
})();

/* ===== offer ladder: switches what Add to cart adds ===== */
(function () {
  'use strict';
  var ladder = document.querySelector('[data-lux-ladder]');
  var scope = document.querySelector('[data-pdp]');
  if (!ladder || !scope) return;

  var opts = ladder.querySelectorAll('[data-ladder-opt]');
  var idField = scope.querySelector('select[name="id"]') || scope.querySelector('input[name="id"]');
  if (!idField || !opts.length) return;

  var baseVariant = ladder.getAttribute('data-base-variant');

  function currentBase() {
    // base follows the variant picker if present
    var sel = scope.querySelector('select[name="id"][data-variant-select]');
    return sel ? sel.value : baseVariant;
  }

  function setField(val) {
    if (idField.tagName === 'SELECT') {
      // bundle variants aren't options in the select; inject if missing
      if (!idField.querySelector('option[value="' + val + '"]')) {
        var o = document.createElement('option');
        o.value = val; o.textContent = 'bundle';
        idField.appendChild(o);
      }
    }
    idField.value = val;
  }

  function activate(opt) {
    opts.forEach(function (o) {
      var on = o === opt;
      o.classList.toggle('is-active', on);
      o.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var v = opt.getAttribute('data-variant');
    setField(v || currentBase());
  }

  opts.forEach(function (opt) {
    opt.addEventListener('click', function () { activate(opt); });
    opt.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(opt); }
    });
  });

  // choosing a shade swatch returns the ladder to the solo option
  scope.querySelectorAll('.pdp__swatch input').forEach(function (input) {
    input.addEventListener('change', function () {
      var solo = opts[0];
      if (!solo.classList.contains('is-active')) activate(solo);
      else setField(currentBase());
    });
  });

  // mirror live solo price (variant changes update the main price element)
  var mainPrice = document.querySelector('[data-dynamic-price]');
  var mirror = ladder.querySelector('[data-dynamic-price-mirror]');
  if (mainPrice && mirror) {
    new MutationObserver(function () { mirror.textContent = mainPrice.textContent; })
      .observe(mainPrice, { childList: true, subtree: true });
  }
})();

/* ===== scroll to top ===== */
(function () {
  'use strict';
  var btn = document.querySelector('[data-lux-top]');
  if (!btn) return;
  var onScroll = function () {
    btn.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.5);
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });
})();
